<template>
  <div v-loading="loading">
    <el-form ref="form" :model="form" @submit.prevent="onSubmit"
      style="margin-left: 130px; width: 100%; min-width: 600px" :inline="true">
      <el-form-item label="Winter Auto Start">
        <el-checkbox v-model="winterEnabled"></el-checkbox>
      </el-form-item>
      <!-- Winter Start-->
      <el-form-item label="Start">
        <el-select v-model="winterStartMonth" placeholder="Select" style="width: 80px"
          @change="winterStartMonthChanged">
          <el-option v-for="item in winterStartStopMonthOptions" :key="item.value" :label="item.label"
            :value="item.value"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select v-model="winterStartDay" placeholder="Select" style="width: 80px" v-if="renderWinterStartDaySelect"
          @change="winterStartDayChanged">
          <el-option v-for="item in winterStartDayOptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <!-- Winter Stop-->
      <el-form-item label="Stop">
        <el-select v-model="winterStopMonth" placeholder="Select" style="width: 80px" @change="winterStopMonthChanged">
          <el-option v-for="item in winterStartStopMonthOptions" :key="item.value" :label="item.label"
            :value="item.value"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select v-model="winterStopDay" placeholder="Select" style="width: 80px" v-if="renderWinterStopDaySelect"
          @change="winterStopDayChanged">
          <el-option v-for="item in winterStopDayOptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <el-form ref="form" :model="form" label-width="250px" @submit.prevent="onSubmit"
      style="width: 60%; min-width: 600px">
      <el-form-item label="Auto Heat Adjust Enabled">
        <el-checkbox v-model="autoHeatAdjustEnabled"></el-checkbox>
      </el-form-item>
      <el-form-item label="Ramp Up Speed">
        <el-input v-model="rampUpSpeed" type="number"></el-input>
      </el-form-item>
      <el-form-item label="Ramp Down Speed">
        <el-input v-model="rampDownSpeed" type="number"></el-input>
      </el-form-item>
    </el-form>

    <el-form ref="form" :model="form" @submit.prevent="onSubmit"
      style="margin-left: 118px; width: 100%; min-width: 600px" :inline="true">
      <el-form-item label="Heatup Adjustment (+%)">
        <el-input v-model="heatup.adjustment" style="width: 80px" placeholder="Heatup Adjustment" type="number">
        </el-input>
      </el-form-item>
      <el-form-item label="Start">
        <el-time-select v-model="heatup.start" :picker-options="{ start: '02:00', step: '00:15', end: '11:30' }"
          placeholder="Start" @change="HeatUpStartChange"></el-time-select>
      </el-form-item>
      <el-form-item label="Duration">
        <el-time-select v-model="heatup.duration" :picker-options="{ start: '00:15', step: '00:15', end: '08:30' }"
          placeholder="Duration" @change="HeatUpDurationChange"></el-time-select>
      </el-form-item>
    </el-form>
    <el-form ref="form" :model="form" @submit.prevent="onSubmit"
      style="margin-left: 118px; width: 100%; min-width: 600px" :inline="true">
      <el-form-item label="Midday Adjustment (-%)">
        <el-input v-model="midday.adjustment" style="width: 80px" placeholder="Heatup Adjustment" type="number">
        </el-input>
      </el-form-item>
      <el-form-item label="Start">
        <el-time-select v-model="midday.start" :picker-options="{ start: '08:30', step: '00:15', end: '18:30' }"
          placeholder="Start" @change="MiddayStartChange"></el-time-select>
      </el-form-item>
      <el-form-item label="Duration">
        <el-time-select v-model="midday.duration" :picker-options="{ start: '00:15', step: '00:15', end: '08:00' }"
          placeholder="Duration" @change="MiddayDurationChange"></el-time-select>
      </el-form-item>
    </el-form>
    <el-form ref="form" :model="form" @submit.prevent="onSubmit"
      style="margin-left: 130px; width: 100%; min-width: 600px" :inline="true">
      <el-form-item label="Night Adjustment (-%)">
        <el-input v-model="night.adjustment" style="width: 80px" placeholder="Heatup Adjustment" type="number">
        </el-input>
      </el-form-item>
      <el-form-item label="Start">
        <el-time-select v-model="night.start" :picker-options="{ start: '15:00', step: '00:15', end: '23:45' }"
          placeholder="Start" @change="NightStartChange"></el-time-select>
      </el-form-item>
    </el-form>
    <div style="margin-left: 200px">
      <light-timeline :items="timelineItems"></light-timeline>
    </div>
    <el-form ref="form" :model="form" @submit.prevent="onSubmit"
      style="margin-left: 118px; width: 100%; min-width: 600px" :inline="true">
      <el-form-item style="margin-top: 10px">
        <el-button type="primary" style="margin-top: 10px" @click="saveDataToPanel">Save to Panel</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import Axios from "axios"
import echarts from "echarts"
import IOService from "@/api/io.service"
import SettingsService from "@/api/settings.service"
import constants from "@/common/constants/system"

export default {
  data() {
    return {
      loading: false,

      winterStartStopMonthOptions: [
        {
          value: 1,
          label: "Jan"
        },
        {
          value: 2,
          label: "Feb"
        },
        {
          value: 3,
          label: "Mar"
        },
        {
          value: 4,
          label: "Apr"
        },
        {
          value: 5,
          label: "May"
        },
        {
          value: 6,
          label: "Jun"
        },
        {
          value: 7,
          label: "Jul"
        },
        {
          value: 8,
          label: "Aug"
        },
        {
          value: 9,
          label: "Sep"
        },
        {
          value: 10,
          label: "Oct"
        },
        {
          value: 11,
          label: "Nov"
        },
        {
          value: 12,
          label: "Dec"
        }
      ],
      winterStartDayOptions: [],
      winterStopDayOptions: [],

      winterStartMonth: 3,
      winterStartDay: 5,
      winterStopMonth: 6,
      winterStopDay: 7,

      renderWinterStartDaySelect: true,
      renderWinterStopDaySelect: true,

      winterEnabled: false,
      autoHeatAdjustEnabled: false,
      rampUpSpeed: "",
      rampDownSpeed: "",
      heatup: {
        adjustment: "",
        start: "",
        duration: ""
      },
      midday: {
        adjustment: "",
        start: "",
        duration: ""
      },
      night: {
        adjustment: "",
        start: ""
      },
      editDialog: {
        visible: false,
        value: "",
        title: "",
        currentValue: ""
      },
      timelineItems: [],
      form: {},
      user: this.$session.get("User")
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    verifySettings() {
      if (isNaN(parseInt(this.heatup.adjustment)) || parseInt(this.heatup.adjustment) < 0 || parseInt(this.heatup.adjustment) > 100) {
        const h = this.$createElement
        this.$notify({
          title: "Heatup Adjustment",
          message: "Value not valid.  Adjustment should be between 0 and 100",
          type: "error"
        })
        return false
      }
      if (isNaN(parseInt(this.midday.adjustment)) || parseInt(this.midday.adjustment) < 0 || parseInt(this.midday.adjustment) > 100) {
        const h = this.$createElement
        this.$notify({
          title: "Midday Adjustment",
          message: "Value not valid.  Adjustment should be between 0 and 100",
          type: "error"
        })
        return false
      }
      if (isNaN(parseInt(this.night.adjustment)) || parseInt(this.night.adjustment) < -100 || parseInt(this.night.adjustment) > 100) {
        const h = this.$createElement
        this.$notify({
          title: "Night Adjustment",
          message: "Value not valid.  Adjustment should be between -100 and 100",
          type: "error"
        })
        return false
      }
      if (isNaN(parseInt(this.rampUpSpeed)) || parseInt(this.rampUpSpeed) < 0 || parseInt(this.rampUpSpeed) > 20) {
        const h = this.$createElement
        this.$notify({
          title: "Ramp Up speed",
          message: "Value not valid.  Value should be between 0 and 20",
          type: "error"
        })
        return false
      }
      if (isNaN(parseInt(this.rampDownSpeed)) || parseInt(this.rampDownSpeed) < 0 || parseInt(this.rampDownSpeed) > 20) {
        const h = this.$createElement
        this.$notify({
          title: "Ramp down speed",
          message: "Value not valid.  Value should be between 0 and 20",
          type: "error"
        })
        return false
      }
      return true
    },
    saveDataToPanel() {
      if (!this.verifySettings()) return

      this.loading = true
      Axios.all([
        SettingsService.changeSetting(this.user.activeZone, "Settings.AHA.Winter.Enabled", this.winterEnabled ? "true" : "false"),
        SettingsService.changeSetting(this.user.activeZone, "Settings.AHA.Winter.Start.Month", this.winterStartMonth),
        SettingsService.changeSetting(this.user.activeZone, "Settings.AHA.Winter.Start.Day", this.winterStartDay),
        SettingsService.changeSetting(this.user.activeZone, "Settings.AHA.Winter.Stop.Month", this.winterStopMonth),
        SettingsService.changeSetting(this.user.activeZone, "Settings.AHA.Winter.Stop.Day", this.winterStopDay),
        SettingsService.changeSetting(this.user.activeZone, "Settings.AHA.Enabled", this.autoHeatAdjustEnabled ? "true" : "false"),
        SettingsService.changeSetting(this.user.activeZone, "Settings.AHA.RampUp", this.rampUpSpeed),
        SettingsService.changeSetting(this.user.activeZone, "Settings.AHA.RampDown", this.rampDownSpeed),
        SettingsService.changeSetting(this.user.activeZone, "Settings.AHA.Adjustment.Heatup", this.heatup.adjustment),
        SettingsService.changeSetting(this.user.activeZone, "Settings.AHA.Adjustment.MidDay", this.midday.adjustment),
        SettingsService.changeSetting(this.user.activeZone, "Settings.AHA.Adjustment.Night", this.night.adjustment),
        SettingsService.changeSetting(this.user.activeZone, "Settings.AHA.Timer.Heatup.Start", this.heatup.start),
        SettingsService.changeSetting(this.user.activeZone, "Settings.AHA.Timer.Heatup.Duration", this.heatup.duration),
        SettingsService.changeSetting(this.user.activeZone, "Settings.AHA.Timer.Midday.Start", this.midday.start),
        SettingsService.changeSetting(this.user.activeZone, "Settings.AHA.Timer.Midday.Duration", this.midday.duration),
        SettingsService.changeSetting(this.user.activeZone, "Settings.AHA.Timer.Night.Start", this.night.start)
      ])
        .then(
          Axios.spread(
            (
              winterEnabledResponse,
              winterStartMonthResponse,
              winterStartDayResponse,
              winterStopMonthResponse,
              winterStopDayResponse,
              ahaEnabledResponse,
              ahaRampUpSpeedResponse,
              ahaRampDownSpeedResponse,
              heatupAdjustmentResponse,
              middayAdjustmentResponse,
              nightAdjustmentResponse,
              heatupStartResponse,
              heatupDurationResponse,
              middayStartResponse,
              middayDurationResponse,
              nightStartResponse
            ) => {
              //The system should update in 10 seconds.
              this.loading = false
              if (
                winterEnabledResponse.data.result != "success" ||
                winterStartMonthResponse.data.result != "success" ||
                winterStartDayResponse.data.result != "success" ||
                winterStopMonthResponse.data.result != "success" ||
                winterStopDayResponse.data.result != "success" ||
                ahaEnabledResponse.data.result != "success" ||
                ahaRampUpSpeedResponse.data.result != "success" ||
                ahaRampDownSpeedResponse.data.result != "success" ||
                heatupAdjustmentResponse.data.result != "success" ||
                middayAdjustmentResponse.data.result != "success" ||
                nightAdjustmentResponse.data.result != "success" ||
                heatupStartResponse.data.result != "success" ||
                heatupDurationResponse.data.result != "success" ||
                middayStartResponse.data.result != "success" ||
                middayDurationResponse.data.result != "success" ||
                nightStartResponse.data.result != "success"
              ) {
                const h = this.$createElement
                this.$notify({
                  title: "Auto Heat",
                  message: "Error trying to save data to panel",
                  type: "error"
                })
              } else {
                this.$notify({
                  title: "Auto Heat",
                  message: "Settings Saved to Panel",
                  type: "info"
                })
              }
            }
          )
        )
        .catch(() => {
          this.loading = false
          const h = this.$createElement
          this.$notify({
            title: "Auto Heat",
            message: "Error trying to save data to panel",
            type: "error"
          })
        })
    },
    generateTimeline() {
      this.timelineItems = [
        {
          tag: this.heatup.start,
          content: "Heatup (Duration - " + this.heatup.duration + ")"
        },
        {
          tag: this.midday.start,
          content: "Midday (Duration - " + this.midday.duration + ")"
        },
        {
          tag: this.night.start,
          content: "Night"
        }
      ]
    },
    getMonthFromString(mon) {
      return new Date(Date.parse(mon + " 1, 2012")).getMonth() + 1
    },
    HeatUpStartChange(data) {
      this.generateTimeline()
    },
    HeatUpDurationChange(data) {
      this.generateTimeline()
    },
    MiddayStartChange(data) {
      this.generateTimeline()
    },
    MiddayDurationChange(data) {
      this.generateTimeline()
    },
    NightStartChange(data) {
      this.generateTimeline()
    },
    winterStartMonthChanged() {
      this.updateWinterStartDayOptions()
    },
    winterStartDayChanged() { },
    winterStopMonthChanged() {
      this.updateWinterStopDayOptions()
    },
    winterStopDayChanged() { },
    updateWinterStartDayOptions() {
      this.winterStartDayOptions = []
      var daysInMonth = 30
      switch (this.winterStartMonth) {
        case 1:
        case 3:
        case 5:
        case 7:
        case 8:
        case 10:
        case 12:
          daysInMonth = 31
          break
        case 2:
          daysInMonth = 28
          if (this.winterStartDay > 28) this.winterStartDay = 28
          break
        default:
          daysInMonth = 30
          if (this.winterStartDay > 30) this.winterStartDay = 30
          break
      }
      for (var day = 1; day <= daysInMonth; day++) {
        this.winterStartDayOptions.push({
          value: day,
          label: day
        })
      }
      this.renderWinterStartDaySelect = false
      this.$nextTick(() => {
        // Add the component back in
        this.renderWinterStartDaySelect = true
      })
    },
    updateWinterStopDayOptions() {
      this.winterStopDayOptions = []
      var daysInMonth = 30
      switch (this.winterStopMonth) {
        case 1:
        case 3:
        case 5:
        case 7:
        case 8:
        case 10:
        case 12:
          daysInMonth = 31
          break
        case 2:
          daysInMonth = 28
          if (this.winterStopDay > 28) this.winterStopDay = 28
          break
        default:
          daysInMonth = 30
          if (this.winterStopDay > 30) this.winterStopDay = 30
          break
      }
      for (var day = 1; day <= daysInMonth; day++) {
        this.winterStopDayOptions.push({
          value: day,
          label: day
        })
      }
      this.renderWinterStopDaySelect = false
      this.$nextTick(() => {
        // Add the component back in
        this.renderWinterStopDaySelect = true
      })
    },
    getData() {
      //Axios.defaults.baseURL = 'http://192.168.137.233:3000';
      Axios.all([IOService.getSettings(this.user.activeZone)]).then(
        Axios.spread((settingsResponse) => {
          console.log(settingsResponse)
          this.winterEnabled = settingsResponse.data.AHA.winter.enabled == "true"
          //Formulate the Winter Start and Stop
          this.winterStartMonth = settingsResponse.data.AHA.winter.start.month
          this.winterStartDay = settingsResponse.data.AHA.winter.start.day
          this.winterStopMonth = settingsResponse.data.AHA.winter.stop.month
          this.winterStopDay = settingsResponse.data.AHA.winter.stop.day
          this.updateWinterStartDayOptions()
          this.updateWinterStopDayOptions()

          this.autoHeatAdjustEnabled = settingsResponse.data.AHA.enabled == "true"
          //AHA
          this.autoHeatAdjustEnabled = settingsResponse.data.AHA.enabled == "true"
          this.rampUpSpeed = settingsResponse.data.AHA.rampUp
          this.rampDownSpeed = settingsResponse.data.AHA.rampDown
          //Adjustments
          this.heatup.adjustment = settingsResponse.data.AHA.adjustment.heatup
          this.midday.adjustment = settingsResponse.data.AHA.adjustment.midday
          this.night.adjustment = settingsResponse.data.AHA.adjustment.night

          this.heatup.start = settingsResponse.data.AHA.timer.heatup.start
          this.heatup.duration = settingsResponse.data.AHA.timer.heatup.duration

          this.midday.start = settingsResponse.data.AHA.timer.midday.start
          this.midday.duration = settingsResponse.data.AHA.timer.midday.duration

          this.night.start = settingsResponse.data.AHA.timer.night.start
          this.generateTimeline()
        })
      )
    }
  }
}
</script>

<style scoped>
.chart-container {
  width: 100%;
  float: left;
}

/*.chart div {
        height: 400px;
        float: left;
    }*/

.el-col {
  padding: 30px 20px;
}
</style>



// WEBPACK FOOTER //
// AutoHeatAdjust.vue?64aff7e6